import { createActions } from 'redux-actions';

export const { setUser } = createActions('SET_USER');
export const { setHeapProperties } = createActions('SET_HEAP_PROPERTIES');
